import { Injectable } from '@angular/core';
import { HttpParams, HttpClient, HttpHeaders } from '@angular/common/http';
import { API_URL, GOOGLE_API_KEY, STRIPE_URL, FACEBOOK_API_URL, MILES_TO_RADIAN } from 'src/app/shared/constants/constants';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ApiService {

  _API_URL: string = API_URL;
  _API_GOOGLE_KEY: string = GOOGLE_API_KEY;
  _STRIPE_URL: string = STRIPE_URL;
  _API_FACEBOOK: string = FACEBOOK_API_URL;

  public constants = {
    // Login & Logout
    LOGIN_API: this._API_URL + 'bevviutils/corporateLogin?emailId={email}&password={password}',
    LOGOUT_API: this._API_URL + 'accounts/logout?access_token={accessToken}',
    SIGNUP_API: this._API_URL + 'accounts',
    FORGOT_PASSWORD: this._API_URL + 'bevviemails/{id}/sendEmail?type=0&emailId={emailID}',

    // SITEMAP
    BEVVI_PRODUCTS: 'https://api.getbevvi.com/api/bevviproducts',

    // Account
    ACCOUNT_DATA_API: this._API_URL + 'accounts/{currentAccountId}?filter={"include":["paymentIds", "userProfiles"]}&access_token={accessToken}',
    ACCOUNT_UPDATE_API: this._API_URL + 'accounts/{currentAccountId}?access_token={accessToken}',
    ACCOUNT_DISCOUNT_INFO_API: this._API_URL + 'accounts/getDiscountInfo?accountId={currentAccountId}&access_token={accessToken}&promoCode={promoCode}',
    GET_FB_DETAIL: this._API_FACEBOOK + '/me?fields=id,name,email,first_name,last_name,short_name&access_token={fbAccessToken}',
    CHECK_FB_USER: this._API_URL + 'socialCredentials?filter={"where":{"facebookId":"{facebookID}"}}',
    CREATE_FB_CREDENTAIL: this._API_URL + 'socialCredentials',
    RESET_PASSWORD: this._API_URL + 'accounts/{accountID}?access_token={accessToken}',
    CHANGE_PASSWORD: this._API_URL + 'bevviutils/resetpassword?emailId={emailID}&curpassword={currentPWD}&newpassword={newPWD}',
    CREATE_ACCOUNT_ON_REMARKETY: this._API_URL + 'accounts/sendAccountInfotoRemarkety?accountId={currentAccountId}&access_token={accessToken}',
    UPDATE_ACCOUNT_ON_REMARKETY: this._API_URL + 'accounts/updateAccountInfotoRemarkety?accountId={currentAccountId}&access_token={accessToken}',
    ACCOUNT_DATA_EMAIL_API: this._API_URL + 'accounts?filter={"where":{"email":"{currentAccountEmail}"}}&access_token={accessToken}',
    ACCESS_TOKEN_VALID: this._API_URL + 'accounts/isValid?access_token={accessToken}',
    KLAVIYO_ACCOUNT_CREATION: this._API_URL + 'accounts/createAccountOnKlaviyo?accountId={accountId}&access_token={accessToken}',
    KLAVIYO_USER_LIST: this._API_URL + 'accounts/sendUserList?accountId={accountId}&access_token={accessToken}',

    // Payment
    RETRIEVE_CUSTOMER: this._STRIPE_URL + 'retrieve_customer',
    LIST_SOURCE_CARDS_API: this._STRIPE_URL + 'list_source_cards',
    LIST_PAYMENT_METHODS_API: this._STRIPE_URL + 'list_payment_methods',
    DELETE_SAVED_CARDS_API: this._STRIPE_URL + 'delete_card',
    SET_DEFAULT_CARD_API: this._STRIPE_URL + 'update_customer',
    ADD_CARD_API: this._STRIPE_URL + 'create_card_corp',
    RELEASE_CHARGE_API: this._STRIPE_URL + 'cancel_capture_charge_b2b',

    // Create Charge
    CREATE_CHARGE_MULTIPLE_API: this._STRIPE_URL + 'create_charge_multiple',
    CREATE_CHARGE_API: this._STRIPE_URL + 'create_charge_b2b',

    // Establishment
    GET_ESTABLISHMENTDETAILS_API: this._API_URL + 'establishments?filter={"where":{"id":"{establishmentID}"},"include":["deliveryCharges","shippingCharges"]}',
    GET_ESTABLISHMENT_STRIPEDETAILS_API: this._API_URL + 'establishments?filter={"where":{"id":"{establishmentID}"},"include":{"bizaccount":["paymentIds"]}}',

    // Offers
    // GET_OFFER_DETAILS_API: this._API_URL + 'offers?filter={"where":{"id":"{offerID}"},"include":[{"product"},"establishment"]}',
    GET_OFFER_DETAILS_API: this._API_URL + 'offers?filter={"where":{"id":"{offerID}"},"include":[{"product":["productPhoto"]},"establishment"]}',
    GET_OFFER_DETAILS_VIA_SLUG_API: this._API_URL + 'bevviproducts/getOffer?slug={slugName}&establishmentId={establishmentID}&isShipping={isShipping}',
    GET_ALL_OFFER_ACCOUNTID_API: this._API_URL + 'offers/getPagedOffers?accountId={currentAccountId}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}',
    GET_ALL_OFFER_GEOLOCATION_API: this._API_URL + 'offers/getPagedOffers?geoLocation={geoLocationParams}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}',
    GET_ALL_OFFER_GEOLOCATION_API_2: this._API_URL + 'offers/getPagedOffers2?establishments={establishmentsID}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}',
    GET_ALL_CORPORATE_OFFERS_API: this._API_URL + 'offers/getCorporateOffers?category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}',
    GET_ALL_DIRECT_VINE_OFFERS_API: this._API_URL + 'corpproducts?filter=%7B%22where%22%20%3A%20%7B%22directFromVineyards%22%3A%20true%7D%7D',
    POST_RECOMMEND_OFFERS: this._API_URL + 'offers/recommendOffers?establishments={establishmentsID}&emailId={currentAccountEmail}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}&source={source}&accountId={currentAccountId}',
    GET_FILTERS_FOR_ALL_OFFER_API: this._API_URL + 'offers/getPagedFilters?inparams={{paramsInfo}}',
    TOPSELLING_PRODUCT: this._API_URL + 'offers?filter={"where":{"establishmentId":"{establishmentId}","qtySold":{"neq":0}, "remQty":{"neq":0}},"order":"qtySold%20DESC","limit":25,"include":"product"}',
    SPONSORED_PRODUCT: this._API_URL + 'offers?filter={"where":{"establishmentId":{"inq":["{establishmentId}","{otherEstablishmentId}"]},"isSponsored":true,"remQty":{"neq":0}},"include":"product"}',
    GET_ESTABLISHMENTID_BYGEOLOCATION: this._API_URL + 'offers/getEstablishmentsByGeoLocation?geoLocation={geoLocationParams}&statename={stateName}&zipcode={zipCode}',
    GET_ESTABLISHMENTID_BYACCOUNTID: this._API_URL + 'offers/getEstablishmentsByGeoLocation?geoLocation={geoLocationParams}&accountId={currentAccountId}&statename={stateName}&zipcode={zipCode}',
    TOPPICKS_PRODUCT: this._API_URL + 'offers/getTopPicks?establishments={establishmentsID}',

    // Bevvi Product
    // GET_BEVVI_PRODUCT: this._API_URL + 'bevviproducts?filter={"where":{"category":"{categoryType}"},"limit":{limit}}',
    GET_BEVVI_PRODUCT: this._API_URL + 'bevviutils/getHomePageProducts?inCategory={categoryType}',

    // Orders
    ORDER_API: this._API_URL + 'orders?filter={"where":{"accountId":"{currentAccountId}"},"order":"createdAt desc","include":[{"orderdetails":["product"]},"establishment"]}',
    ORDER_DELIVERY_FEES_API: this._API_URL + 'orders/getDeliveryFee?accountId={currentAccountId}',
    // GET_ORDER_API: this._API_URL + 'orders?filter={"where":{"id":"{orderID}"},"include":["transactions", "account", "establishment", {"orderdetails":{"offer":[{"product"}]}}]}',
    GET_ORDER_API: this._API_URL + 'orders?filter={"where":{"id":"{orderID}"},"include":["transactions", "account", "establishment", {"orderdetails":{"offer":[{"product":["productPhoto"]}]}}]}',
    ORDER_DOWNLOAD_API: this._API_URL + 'corporders/getShippingInfo?corpOrderInfoNum={corpOrderNum}',

    // SHOPPING
    // GETSHOPPING_CART_API: this._API_URL + 'shoppingcarts?filter={"where":{"accountId":"{currentAccountId}","state":0},"include":[{"product"},{"offer":["establishment"]}]}',
    GETSHOPPING_CART_API: this._API_URL + 'shoppingcarts?filter={"where":{"accountId":"{currentAccountId}","state":0},"include":[{"product":["productPhoto"]},{"offer":["establishment"]}]}',
    GETSHOPPING_CART_COUNT_API: this._API_URL + 'shoppingcarts/count?where={"accountId":"{currentAccountId}", "state":0}',
    ADD_TO_SHOPPING_CART_API: this._API_URL + 'shoppingcarts/addOrUpdate?accountId={currentAccountId}&quantity={quantity}&productId={productID}&offerId={offerID}&establishmentId={establishmentID}',
    ADDUPDATE_SHOPPING_CART_DATA_API: this._API_URL + 'shoppingcarts/addUpdateCart?items=',
    UPDATE_SHOPPING_CART_QUANTITY: this._API_URL + 'shoppingcarts/{cartID}',
    REMOVE_SHOPPING_CART: this._API_URL + 'shoppingcarts/update?where={"id":"{cartID}", "state":0}',
    EMPTY_SHOPPING_CART: this._API_URL + 'shoppingcarts/update?where={"accountId":"{currentAccountId}", "state":0}',
    PRE_CHECKOUT_API: this._API_URL + 'shoppingcarts/precheckout?accountId={currentAccountId}',
    GET_BEVVI_PRODUCT_ID: this._API_URL + 'bevviutils/getBevviProductId?productId={productID}',

    // CORPORATE CART
    CORPORATE_GETSHOPPING_CART_API: this._API_URL + 'corpshoppingcarts?filter={"where":{"accountId":"{currentAccountId}","state":0},"include":["corpProduct"]}',
    CORPORATE_GETSHOPPING_CART_COUNT_API: this._API_URL + 'corpshoppingcarts/count?where={"accountId":"{currentAccountId}", "state":0}',
    CORPORATE_ADD_TO_SHOPPING_CART_API: this._API_URL + 'corpshoppingcarts/addOrUpdate?accountId={currentAccountId}&quantity={quantity}&corpProductId={corpProductId}',
    CORPORATE_ADD_TO_SHOPPING_CART_POST_API: this._API_URL + 'corpshoppingcarts/',
    // CORPORATE_ADD_TO_SHOPPING_CART_POST_API: this._API_URL + 'corporderinfos/addShoppingCartItem',
    CORPORATE_ADDUPDATE_SHOPPING_CART_DATA_API: this._API_URL + 'corpshoppingcarts/addUpdateCart?items=',
    CORPORATE_UPDATE_SHOPPING_CART_QUANTITY: this._API_URL + 'corpshoppingcarts/{cartID}',
    CORPORATE_REMOVE_SHOPPING_CART: this._API_URL + 'corpshoppingcarts/update?where={"id":"{cartID}", "state":0}',
    CORPORATE_EMPTY_SHOPPING_CART: this._API_URL + 'corpshoppingcarts/update?where={"accountId":"{currentAccountId}", "state":0}',
    CORPORATE_PRE_CHECKOUT_API: this._API_URL + 'corpshoppingcarts/precheckout?accountId={currentAccountId}',
    CORPPORATE_TOP_PICKS_API: this._API_URL + 'offers/getCorpTopPicks',

    // CART
    GET_DELIVERY_MESSAGE_API: this._API_URL + 'bevviutils/getMinAmountForDelivery?establishmentId={establishmentID}',
    GET_TAX_RATE_API: this._STRIPE_URL + 'getTaxRate/{latitude}/{longitude}',
    VALIDATE_DELIVERY_DATE: this._API_URL + 'bevviutils/validateDeliveryDate?establishmentId={establishmentID}&date={date}&access_token={accessToken}',

    // DeliveryLocation
    ADD_DELIVERY_LOCATION_API: this._API_URL + 'deliverylocations',
    GET_DELIVERY_LOCATION_API: this._API_URL + 'deliverylocations?filter={"where":{"accountId":"{currentAccountId}"},"order":"createdAt desc"}',
    PATCH_DELIVERY_LOCATION_API: this._API_URL + 'deliverylocations/{locationID}',

    // Tax Rate
    GET_TAX_RATE_DB: this._API_URL + 'taxRates?filter={"where":{"zip":"{zipCode}"}}',

    // Location
    ADD_LOCATION_API: this._API_URL + 'locations',

    // NewsLetter Subcription
    SUBSCRIBE_NEWSLETTER: this._API_URL + 'EmailRepos',

    // Bartender
    BOOK_BARTENDER: this._API_URL + 'bartenders',

    // Promo
    GET_PROMO_USER: this._API_URL + 'promousers?filter={"where":{"accountId":"{currentAccountId}","promoCode":"{promoCode}"}}',

    // Bevvi AD
    GET_BEVVI_AD: this._API_URL + 'bevviads/getImageBanner?isReceipt={receipt}',
    GET_ALL_COMPANY_OFFER: this._API_URL + 'offers/getAdsPagedOffers?curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&companyName={companyName}&isCorp=true',
    // GET_ALL_COMPANY_OFFER_ACCOUNTID_API: this._API_URL + 'offers/getPagedOffers?accountId={currentAccountId}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={"{displayName}":"{value}"}&searchBy={searchBy}',

    // Remarkety
    POST_FORM_DATA_TO_REMARKETY: 'https://app.remarkety.com/api/v1/stores/{store_id}/contacts',

    // Product Recommendation
    POST_OFFERS_LIST: 'https://service.tangent.ai/prorec?emailId={currentAccountEmail}&geoLocation={geoLocationParams}&category={categoryType}&curPageNum={currPage}&offersPerPage={offersPerPage}&sortBy={sort}&filters={{filtersData}}&searchBy={searchBy}&accountId={currentAccountId}&source={source}',

    // Recipient
    RECIPIENT_CART: this._API_URL + 'recipientorders',

    // CorpProduct
    GET_CORP_PRODUCT: this._API_URL + 'corpproducts?filter={"where":{"slug":"{slugName}"}}',

    // CorpOrder
    CREATE_CORP_ORDER_INFO: this._API_URL + '/corporderinfos/createCorpOrderInfo',
    UPDATE_GIFT_SHIPPING_CORP: this._API_URL + 'corporderinfos/updateGiftAndShippingOptions',
    ADD_UPDATE_RECIPIENT_CART: this._API_URL + 'corporderinfos/addUpdateRecipient',
    GET_CORP_ORDER_INFO: this._API_URL + 'corporderinfos/getCorpOrderInfo?accountId={currentAccountId}',
    CLEAR_CORP_ORDER_INFO: this._API_URL + 'corporderinfos/clearRecipients',
    CORP_INFO_ORDER_HISTORY: this._API_URL + 'corporderinfos/getCorpOrderInfoHistory?accountId={currentAccountId}',
    CORP_INFO_ORDER_DETAIL: this._API_URL + 'corporderinfos/getCorpOrderInfoDetails?accountId={currentAccountId}&corpOrderInfoId={corpOrderId}',
    CORP_ORDER_HISTORY: this._API_URL + 'corporders/getCorpOrderHistory?accountId={currentAccountId}',
    CORP_ORDER_DETAIL: this._API_URL + 'corporders/getCorpOrderDetails?accountId={currentAccountId}&corporderId={corpOrderId}',
    ADD_BARTENDER: this._API_URL + 'corporderinfos/addUpdateBartender?accountId={currentAccountId}&eventDate={eventDate}&eventStartTime={eventStartTime}&duration={duration}&subTotal={subTotal}&bartenderType={bartenderType}&timeZone={eventTimeZone}',
    CORPORATE_CLEAR_SHOPPING_CART: this._API_URL + '/corporderinfos/clearShoppingCart?accountId={currentAccountId}&shoppingCartId={shoppingCartId}',
    CORPORATE_PROMO_CODE: this._API_URL + 'corporderinfos/getCorpPromotionDiscount?accountId={currentAccountId}&promoCode={promoCode}',
    POST_ORDER_ON_KLAVIYO: this._API_URL + 'bevviutils/sendOrderOnKlaviyo',
    POST_FAIL_ORDER_ON_KLAVIO: this._API_URL + 'bevviutils/paymentFailedOnKlaviyo',
    // Payment CorpOder
    PAY_CORP_ORDER: this._STRIPE_URL + 'create_corp_charge_b2b',
    DOWNLOAD_ORDER: this._API_URL + 'corporders/downloadAll?accountId=${currentAccountId}&start=${startDate}&end=${endDate}&access_token=${accessToken}',
    SCHEDULE_CORP_ORDER: this._API_URL + 'corporderinfos/createFutureCorpOrderInfo',

    // Upload Image
    UPLOAD_IMAGE: this._STRIPE_URL + 'upload_product_image_b2b',
  };

  public status_codes = {
    CREATE: 201,
    DELETE: 204,
    BAD_REQUEST: 400,
    UNAUTHORIZED: 401,
    PREMISSION_DENIED: 403,
    NOT_FOUND: 404,
    SERVER_ERROR: 500
  }

  public httpOptions = {
    headers: new HttpHeaders({'Content-Type': 'application/json'})
  };

  public getHTTPOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + btoa('bevvi:getbevvi'),
      'Content-Type': 'application/json'
    })
  }

  public userCurrentLocation: any = {};
  public establishmentQuery: string = "";
  public establishmentID: any;

  private localhost: boolean = true;

  constructor(private http:HttpClient) { }

  // GET DATA
  public getData(url: string, params: Object, isParsingRequired: boolean, token?: string, limit?: number, offset?: number): Observable<any> {

    if (isParsingRequired) {
      url = this.parseUrl(url, params);
    }

    console.log(url);
    return this.http.get<any>(`${url}`);
  }

  public postData(url: string, data: any, params: Object, isParsingRequired: boolean, token?: string) {

    if (isParsingRequired) {
      url = this.parseUrl(url, params);
    }

    // if (auth) {
    //   return this.http.post(`${url}`, data, this.getHTTPOptions);
    // }
    return this.http.post(`${url}`, data, this.httpOptions);
  }

  public patchData(url: string, data: any, params: Object, isParsingRequired: boolean, token?: string) {

    if (isParsingRequired) {
      url = this.parseUrl(url, params);
    }

    return this.http.patch(`${url}`, data, this.httpOptions);
  }

  public putData(url: string, data: any, params: Object, isParsingRequired: boolean, token?: string): Observable<any> {
    if (isParsingRequired) {
      url = this.parseUrl(url, params);
    }

    return this.http.put(`${url}`, data, this.httpOptions);
  }

  public deleteData(url: string, params: Object, isParsingRequired: boolean, token: string) {
  }

  public getImage(url: string): Observable<Blob> {
    return this.http.get(url, {responseType: 'blob'});
  }

  public postFormData(url: string, formData: any): Observable<any> {
    // let httpOptions = {
    //   headers: new HttpHeaders({
    //     'Content-Type': 'multipart/form-data'
    //   })
    // }
    return this.http.post(`${url}`, formData);
  }

  private parseUrl(url : string, params ?: object){
    var parsedUrl = url;
    if(params){
      Object.keys(params).forEach(function(k) {
        parsedUrl = parsedUrl.replace('{' + k + '}', params[k]);
      });
    }
    return parsedUrl;
  }

}
